module.exports = __webpack_public_path__ + "img/icpieces.59f5c4a0.png";